(function ($) {

    var initializeBlock = function ($block) {
        $block.find('.customTabs-title').click(function (event) {

          if (!$(this).hasClass('active')) {
            const $parent = $(this).closest('.block'),
            index = $parent.find('.customTabs-title').index($(this));
            
            $parent.find('.customTabs-title').each(function(i) {
                if(i === index) {
                    $(this).toggleClass('active');
                } else {
                    $(this).removeClass('active');
                }
            });

            $parent.find('.customTabs-content').each(function(i) {
                if(i === index) {
                    $(this).toggleClass('active');
                } else {
                    $(this).removeClass('active');
                }
            });

            $parent.find('.mediaBlocks .mediaBlock').each(function(i) {
                if(i === index) {
                    $(this).toggleClass('active');
                } else {
                    $(this).removeClass('active');
                }
            });
          }

        });
    }

    $(document).ready(function () {
        $('.block--accordion-with-media-block').each(function () {
            initializeBlock($(this));
        })
    })

    if (window.acf) {
        window.acf.addAction('render_block_preview/type=accordion-with-media-block', initializeBlock);
    }

})(jQuery);
